import { FC } from 'react';
import { IconProps } from './type';

export const PickemIcon: FC<IconProps> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="#23E996"
      />
      <path
        d="M8.95989 11.1675V12.6164H9.65676C9.94995 12.6164 10.1585 12.6752 10.2824 12.793C10.4063 12.9108 10.4684 13.1061 10.4687 13.3791C10.4687 13.6572 10.4051 13.8573 10.2792 13.9797C10.1534 14.1021 9.94543 14.1634 9.65676 14.1634H7.31625C7.01855 14.1634 6.80551 14.1021 6.67711 13.9797C6.5487 13.8573 6.48405 13.6569 6.48315 13.3786C6.48315 13.1294 6.54405 12.9398 6.66583 12.8099C6.78761 12.6799 6.96563 12.6153 7.19988 12.6159H7.31489V7.3462H7.19988C6.96984 7.3462 6.79288 7.27905 6.66899 7.14476C6.5451 7.01047 6.48315 6.81853 6.48315 6.56895C6.48315 6.296 6.54811 6.0969 6.67936 5.97211C6.81061 5.84731 7.02171 5.78516 7.31489 5.78516H10.1087C11.2135 5.78516 12.0489 6.00654 12.6148 6.4493C13.1806 6.89206 13.4641 7.54468 13.465 8.40715C13.465 9.31604 13.1831 10.0036 12.6193 10.4697C12.0555 10.9359 11.219 11.1695 10.11 11.1708L8.95989 11.1675ZM8.95989 7.3462V9.57839H9.92063C10.4522 9.57839 10.8525 9.48414 11.1213 9.29563C11.3902 9.10712 11.5242 8.82467 11.5236 8.44827C11.5236 8.09494 11.385 7.82293 11.1078 7.63223C10.8306 7.44154 10.4348 7.3462 9.92063 7.3462H8.95989Z"
        fill="white"
      />
    </svg>
  );
};
